<template>
  <section :class="`news-list--${ type }`" class="news-list">
    <grid-container>
      <grid-row>
        <div
          v-for="(article, i) in articles"
          :key="i"
          class="news-list__article"
        >
          <article-component
            :heading="article.title"
            :description="article.desc"
            :photo="article.photo"
            :link="article.link"
          />
        </div>
      </grid-row>
    </grid-container>
  </section>
</template>

<script>
import ArticleComponent from '@/components/Article'

export default {
  components: {
    ArticleComponent
  },
  props: {
    type: {
      type: String,
      default: 'left',
      validator: propValue => ['left', 'right'].includes(propValue)
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    articles () {
      return this.items.slice(0, 2)
    }
  }
}
</script>

<style lang="scss" scoped>
  .news-list {
    &--left &__article {
      &:first-child {
        @include grid-column((xs: 12, md: 6, lg: 7));
      }

      &:last-child {
        @include grid-column((xs: 12, md: 6, lg: 5));
      }
    }

    &--right &__article {
      &:first-child {
        @include grid-column((xs: 12, md: 6, lg: 5));
      }

      &:last-child {
        @include grid-column((xs: 12, md: 6, lg: 7));
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Home/NewsList.vue